import { Injectable } from '@angular/core';
import { SafeArea } from 'capacitor-plugin-safe-area';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

@Injectable({ providedIn: 'root' })
export class StatusBarService {
  safeAreaInPx: number = 0;

  /**
   * This service is important since Capacitor 7 for Android versions, as safe area is no longer managed by Capacitor.
   *
   * We need to calculate the height of the status bar and apply padding accordingly.
   * For android we calculate safe area with screen.height - window.innerHeight
   * For iOS, we retrieve the value of the environment variable safe-area-inset-top to determine the height of the status bar (and any potential notch).
   *
   * We then store the result in a single variable --safe-area to simplify its usage.
   */
  async initialize(safeArea: HTMLElement): Promise<void> {
    const platform = Capacitor.getPlatform();

    if (platform === 'web') {
      // Do nothing on web as there's no status bar
      document.documentElement.style.setProperty('--safe-area', '0px');
    } else if (platform === 'android') {
      const statusBarHeight = (await SafeArea.getStatusBarHeight()).statusBarHeight;
      document.documentElement.style.setProperty('--safe-area', `${statusBarHeight}px`);
      await StatusBar.setStyle({ style: Style.Dark });

      this.safeAreaInPx = statusBarHeight;
    } else {
      const safeAreaTop = safeArea ? window.getComputedStyle(safeArea).getPropertyValue('padding-top') : 0;
      const safeAreaTopNumber = safeAreaTop ? Number(parseInt(safeAreaTop.replace('px', ''))) : 0;
      this.safeAreaInPx = safeAreaTopNumber;
      document.documentElement.style.setProperty('--safe-area', `${safeAreaTopNumber}px`);
    }
  }
}
